import { IconProps } from "./IconProps";

const LightBulb: React.FC<IconProps> = ({
  width = 44,
  height = 44,
  color = "#FCFCFD",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 44" fill="none">
      <g clipPath="url(#clip0_32_93)">
        <path
          d="M14.6257 35.9903C14.6257 35.0057 15.4239 34.2075 16.4085 34.2075H27.1053C28.0899 34.2075 28.8881 35.0057 28.8881 35.9903V37.7731C28.8881 40.7269 26.4935 43.1215 23.5397 43.1215H19.9741C17.0203 43.1215 14.6257 40.7269 14.6257 37.7731V35.9903Z"
          fill={color}
        />
        <path
          d="M36.0194 14.5968C36.0194 19.1009 33.9316 23.1173 30.671 25.7311V27.0764C30.671 29.0456 29.0746 30.642 27.1054 30.642H23.5398V20.6837L26.5832 17.6403C27.2794 16.944 27.2794 15.8152 26.5832 15.119C25.887 14.4228 24.7582 14.4228 24.062 15.119L21.757 17.424L19.452 15.119C18.7558 14.4228 17.627 14.4228 16.9308 15.119C16.2346 15.8152 16.2346 16.944 16.9308 17.6403L19.9742 20.6837V30.642H16.4086C14.4394 30.642 12.843 29.0456 12.843 27.0764V25.7311C9.58242 23.1173 7.49463 19.1009 7.49463 14.5968C7.49463 6.71995 13.8801 0.334473 21.757 0.334473C29.6339 0.334473 36.0194 6.71995 36.0194 14.5968Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_32_93">
          <rect
            width="42.7871"
            height="42.7871"
            fill="white"
            transform="translate(0.363403 0.334473)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LightBulb;
